import React, {useContext} from 'react';
import {
    Link,
} from 'react-router-dom';
import logo from '../../icons/neologo108x54.png';
import LangSelector from '../../components/LangSelector';
import Navbar from '../../components/Navbar';
import {LangContext} from '../../components/LangProvider';
import {LoginContext} from '../../components/LoginProvider';
import './Header.css'

function Header(props){
    const {lang} = useContext(LangContext);
    const {userid} = useContext(LoginContext);
    const baseUrl = window.location.origin;
    const bookmarklet = `<a href="javascript:var d=document,w=window,e=w.getSelection,k=d.getSelection,x=d.selection,s=(e?e():(k)?k():(x?x.createRange().text:'')),f='${baseUrl}/${userid}',l=d.location,e=encodeURIComponent,u=f+'?u='+e(l.href)+'&t='+e(d.title)+'&s='+e(s);a=function(){if(!(z=w.open(u,'t'))){l.href=u;}else{z.focus();}};if(navigator.userAgent.indexOf('Firefox') != -1)setTimeout(a,0);else a();void(0)"><span className="label label-info" title="Drag this bookmarklet to your browser bookmarkbar" >${lang.header.bookmarklet}</span></a>`;
    return(
        <>     
        {/* <!-- Navigation --> */}
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
          <div className="container">
            <Link className="navbar-brand" to="/home"><img src={logo} className="logo" alt="logo_icon" />{lang.header.company}</Link>
            <LangSelector/>
            <button className="btn btn-link bookmarklet" dangerouslySetInnerHTML={{__html: bookmarklet}}></button>
            <Navbar/>
          </div>
        </nav>
        </>
    );
}

export default Header;